export const hasPath = <T>(
  destination: T,
): destination is T & { path: string } => {
  if (typeof destination === 'object' && destination !== null) {
    return 'path' in destination;
  }
  return false;
};
